import React from 'react';

const planCardStyle: React.CSSProperties = {
  border: '1px solid var(--color-border)',
  borderRadius: 16,
  padding: 16,
  background: 'var(--color-surface)'
};

const PlanSelection: React.FC = () => {
  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Choose a plan</h3>
      <p style={{ color: 'var(--color-text-muted)' }}>Select a plan to unlock the dashboard.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 }}>
        <div style={planCardStyle}>
          <h4>Free</h4>
          <p style={{ color: 'var(--color-text-muted)' }}>100 items/day</p>
          <button className="button full">Continue with Free</button>
        </div>
        <div style={planCardStyle}>
          <h4>Pro</h4>
          <p style={{ color: 'var(--color-text-muted)' }}>Priority processing</p>
          <button className="button full">Start Pro Trial</button>
        </div>
        <div style={planCardStyle}>
          <h4>Enterprise</h4>
          <p style={{ color: 'var(--color-text-muted)' }}>SLA + SSO</p>
          <button className="button full">Contact Sales</button>
        </div>
      </div>
    </div>
  );
};

export default PlanSelection; 